var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 456 304.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-l") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.87,5a146.88,146.88,0,1,0,73.44,274.09A147.62,147.62,0,0,1,170.22,223"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.22,80.75a147.65,147.65,0,0,1,55.09-56.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445.62,151.87A146.91,146.91,0,0,0,225.31,24.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.4,80.75a73.51,73.51,0,0,1,90.16,86.55l56.34,56.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.31,279.09A147.62,147.62,0,0,0,280.4,223a73.46,73.46,0,0,1,0-142.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.22,223a147,147,0,0,1,0-142.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.31,279.09a147,147,0,0,0,150.81-2.36l22.95,22.95L451,247.75l-24.1-24.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoL);
export default __webpack_public_path__ + "static/media/logo-l.316163df0a8e832c8c6436a3416362e4.svg";
export { ForwardRef as ReactComponent };